import React from 'react';
import ArrowCounterClockwise from '@uber/base-icons/arrow-counter-clockwise';
import { useStyletron } from 'styletron-react';
import ToolbarButton from '../../../../../common/toolbar-button';
export const UNDO_SELECTOR_ID = 'undo-button';
export const REDO_SELECTOR_ID = 'redo-button';
type PropsT = {
  canRedo: boolean;
  canUndo: boolean;
  undoAction: () => void;
  redoAction: () => void;
};
const undoAttributes = {
  'data-testid': 'undo-button',
  'data-selector-id': UNDO_SELECTOR_ID
};
const redoAttributes = {
  'data-testid': 'redo-button',
  'data-selector-id': REDO_SELECTOR_ID
};
function UndoRedo({
  canRedo,
  canUndo,
  undoAction,
  redoAction
}: PropsT) {
  const [css] = useStyletron();
  return <>
      <ToolbarButton title="Undo" attributes={undoAttributes} disabled={!canUndo} onClick={undoAction}>
        <ArrowCounterClockwise title="Undo" />
      </ToolbarButton>
      <ToolbarButton title="Redo" disabled={!canRedo} onClick={redoAction} attributes={redoAttributes}>
        <span className={css({
        display: 'inline-flex',
        alignItems: 'center',
        transform: 'rotateY(180deg)'
      })}>
          <ArrowCounterClockwise title="Redo" size={16} />
        </span>
      </ToolbarButton>
    </>;
}
export default UndoRedo;